import { PageContentContainer } from '../components/PageContentContainer/PageContentContainer';

function DownloadPage() {
  return (
    <PageContentContainer>
      <div>Windows/Mac/Linux Download</div>
      <div>
        Page In Development ... beta download link will be released here
      </div>
    </PageContentContainer>
  );
}

export default DownloadPage;
